import React from "react";
import { BackArrow, Pin } from "./icons";
import { gutter, oneLine } from "./look";

function DeliverTo({ label }) {
  return (
    <div className="d-flex align-items-center" style={{ ...gutter, padding: "10px 0", marginBottom: 5, fontSize: 12 }}>
      <Pin />
      <span style={{ marginLeft: 10, fontWeight: 500, color: "#444" }}>Deliver to</span>
      <span style={{ ...oneLine, marginLeft: 5, fontWeight: 300, color: "#555", maxWidth: "60%" }}>{label}</span>
    </div>
  );
}

function SurplusHeader() {
  return (
    <div className="d-flex align-items-center" style={{ ...gutter, height: 56, fontSize: 16, fontWeight: 600 }}>
      <BackArrow />
      <span style={{ marginLeft: 12 }}>Foodoor Surplus</span>
    </div>
  );
}

export default function ScreenTop({ screen, franchise }) {
  return screen === "surplus" ? <SurplusHeader /> : <DeliverTo label={franchise.name} />;
}
